<script>
import options from "./CheckoutCourseParticipants.options";
export default options;
</script>

<template>
    <article class="nti-checkout-participants" v-if="doesContainCourse">
        <h1 class="nti-webshop-checkout__title">{{ verifyLabel('participantsHeader') }}</h1>
        <p class="nti-webshop-checkout__title-paragraph" v-html="verifyLabel('courseParticipantsSubTitleLabel')"></p>
        
        <template v-for="(course,courseIndex) in form" :key="courseIndex">
            <section class="nti-checkout-participants__container toggle-box">
                <div :data-target="`#${course.code}`">
                    <input
                        :name="course.hiddenFieldname"
                        type="hidden"
                        :value="course.code"
                    />
                    <h3 class="nti-checkout-participants__course-info__title">{{course.courseTitle}}</h3>
                    <div class="nti-checkout-participants__course-info">
                        <div class="nti-checkout-participants__course-info__container">
                            <p class="nti-checkout-participants__course-info__label">{{ verifyLabel('courseParticipantsDateLabel') }}</p>
                            <p class="nti-checkout-participants__course-info__label">{{ verifyLabel('courseParticipantsLocationLabel') }}</p>
                            <p class="nti-checkout-participants__course-info__label">{{ verifyLabel('courseParticipantsDurationLabel') }}</p>
                            <p class="nti-checkout-participants__course-info__label" v-html="verifyLabel('courseParticipantsAmountLabel')"></p>
                        </div>
                        <div class="nti-checkout-participants__course-info__container">
                            <p>{{course.date}}</p>
                            <p>{{course.location}}</p>
                            <p>{{course.duration}}</p>
                            <p>{{course.participantCount}}</p>
                        </div>
                    </div>
                </div>

                <div
                    class="toggle-box__target collapse show"
                    :id="course.code"
                    data-js="toggle-box-target"
                    style>

                    <template v-for="(participant,participantIndex) in course.participants" :key="participantIndex">
                        <div class="add-participants__participant nti-checkout-participants__participant__wrapper">
                            <div class="nti-checkout-participants__participant__container">
                                <div class="nti-checkout-participants__participant__line"></div>
                                <span class="nti-checkout-participants__participant"><h4>{{ verifyLabel('participantsNumberText') }} {{participantIndex+1}}</h4></span>
                            </div>
                        </div>

                        <div class="nti-checkout-participants__field-container">
                        <template v-for="(field) in participant" :key="field.displayName">
                            
                                <div class="form-group nti-checkout-billing__form-group">
                                    <label :for="field.name">{{field.displayName}}</label>
                                    <input
                                        :disabled="disableField"
                                        class="form-control"
                                        :class="displayValidationResult(field)"
                                        :id="field.name"
                                        :name="field.name"
                                        :required="field.required"
                                        :type="field.type"
                                        autocomplete="off"
                                        v-model="field.value"
                                    />
                                    <div class="invalid-feedback">{{ verifyLabel('inputValidationErrorLabel') }}</div>
                                </div>
                            
                        </template>
                        </div>

                    </template>
                </div>

            </section>
        </template>

    </article>
</template>